<template>
  <div class="fg-recap">
    <div class="fg-recap__main">
      <span class="fg-recap__route">{{ journeySummary }}</span>
      <span class="fg-recap__sep"> · </span>
      <span class="fg-recap__item">{{ datesSummary }}</span>
      <template v-if="passengersSummary">
        <span class="fg-recap__sep"> · </span>
        <span class="fg-recap__item">{{ passengersSummary }}</span>
      </template>
      <template v-if="hasVehicle">
        <span class="fg-recap__sep"> · </span>
        <span class="fg-recap__item">{{ vehicleSummary }}</span>
      </template>
    </div>
    <button type="button" class="fg-recap__edit" @click="router.goTo(BookingStep.Search)">
      {{ t('common.edit') }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from '../../store'
import { useI18n } from '../../i18n'
import { useRouter } from '../../router'
import { useSearchSummary } from '../../composables/useSearchSummary'
import { BookingStep } from '../../../../shared/types/enums'

const store = useStore()
const router = useRouter()
const { t } = useI18n()
const { journeySummary, datesSummary, passengersSummary, vehicleSummary } = useSearchSummary()

// Contrairement à Search.vue (4 cartes fixes, "Aucun véhicule" affiché), le
// rappel omet purement le segment véhicule quand rien n'est sélectionné.
const hasVehicle = computed(() => Boolean(store.search.vehicle?.type))
</script>
